import { loadMoreComponent } from "../transport/components.js";
import { findComponent, handleResponse, PARSER } from "./_common.js";

export async function loadNextPage(componentId, pageNumber, excludePostIds, lastPostId) {
    const element = findComponent(window.document, componentId);

    const lazyDeps = element.dataset.lazyDeps;
    const response = await loadMoreComponent(
        componentId,
        lazyDeps,
        pageNumber,
        excludePostIds,
        lastPostId
    );
    handleResponse(response);

    const document = PARSER.parseFromString(response.component_html, "text/html");
    const rootComponent = findComponent(document, componentId);

    return rootComponent;
}
